export default __webpack_public_path__ + "static/media/91banana.e5ec1392.jpg";